<template>
  <div class="mm-page-main">
    <div class="page-header">
      <div class="page-title">添加電話卡</div>
      <div @click="pageback" class="page-back">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-back"></use>
        </svg>
      </div>
    </div>
    <div class="pagemain">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px" label-position="left">
        <div class="form-group">
          <div class="form-group-content">
            <div class="mm-row">
							<div class="mm-col">
								<el-form-item label="代號" prop="code">
									<el-input v-model="form.code" clearable></el-input>
								</el-form-item>
							</div>
						</div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="電話卡號碼" prop="phone">
                  <el-input v-model="form.phone" clearable></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="網絡提供商" prop="service">
                  <el-input v-model="form.service" clearable></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="電話卡到期日" prop="endtime">
                  <el-date-picker type="date" placeholder="選擇日期" v-model="form.endtime" style="width: 100%;" clearable></el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="電話卡餘額" prop="money">
                  <el-input v-model="form.money" clearable></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="備註" prop="remarks">
                  <el-input v-model="form.remarks" clearable></el-input>
                </el-form-item>
              </div>
            </div>

          </div>
        </div>

        <div class="form-submit">
          <el-button @click="formsubmit('form')" type="primary">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {

  data () {
    return {
      form: {
        remarks: '',
      },
      rules: {

        phone: [{
          required: true,
          message: '請填寫電話號碼',
        }, {
          pattern: /^[0-9]+$/,
          message: '只能輸入數字'
        }],
        // endtime: [{
        //   required: true,
        //   message: '請選擇到期日期',
        // }],
        money: [{
          required: true,
          message: '請填寫餘額',
        }, {
          pattern: /^[0-9\.]+$/,
          message: '只能輸入數字和小數'
        }]



      }
    };
  },
  methods: {

    pageback () {
      this.$router.go(-1);
    },
    formsubmit (form) {

      this.$refs[form].validate((valid) => {
        if (valid) {
          let data = this.form;
          this.loading = true;
          this.post('/api/bank/bank_phone_save', {
            data: data
          }).then((res) => {

            if (res == 'success') {
              this.$message({
                showClose: true,
                message: '添加電話卡成功！',
                type: 'success',
                onClose: (() => {
                })
              });
              this.pageback();
            } else {
              this.$message({
                showClose: true,
                message: '添加電話卡失敗，請重試！',
                type: 'error',

              });
            }

            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        }
      });
    },


  }

};
</script>
<style scoped>
</style>
